import React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from "gatsby"
import { Container, Row, Col } from '../../../components/ui/wrapper'
import Heading from '../../../components/ui/heading'
import { PageHeaderWrap } from './page-header.style'
import PageHeaderCustomBg from '../../../components/pageheadercustombg';


const PageHeader = ({ pageContext, location, title, sectionStyle, titleStyle, descStyle }) => {
    const PageHeaderImageData = useStaticQuery(graphql`
        query TechPageHeaderQuery {
            file(relativePath: {eq: "images/banner/technology_top_banner.jpg"}) {
                childImageSharp {
                    gatsbyImageData(layout: FULL_WIDTH, quality: 75, placeholder: BLURRED)
                }
            }
        } 
    `);
    const imageData = PageHeaderImageData.file?.childImageSharp?.gatsbyImageData;
    if (!imageData) {
        console.warn("Technology PageHeader: Image not found");
    }
    return <PageHeaderCustomBg
        pageContext={pageContext}
        location={location}
        title={title}
        image={imageData}
        textColor="#4b1e79"
    />
}

PageHeader.propTypes = {
    descStyle: PropTypes.object,
    titleStyle: PropTypes.object
}

PageHeader.defaultProps = {
    titleStyle: {
        as: 'h1',
        color: "#4b1e79",
        mb: '15px'
    },
    descStyle: {
        as: "h5",
        color: "#4b1e79",
        fontweight: 400
    }
}

export default PageHeader;